import { SearchOutlined } from '@ant-design/icons';

import { StyledButton } from './styled';
const SearchCarRentalButton = ({
  onClick,
  disabled,
}: {
  onClick: VoidFunction;
  disabled?: boolean;
}) => {
  return (
    <StyledButton onClick={onClick} disabled={disabled}>
      <SearchOutlined />
      ARA
    </StyledButton>
  );
};

export default SearchCarRentalButton;
